'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const fastdom=require('fastdom');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

PointPlotterDirective=function(_BaseControllerBacked){_inherits(PointPlotterDirective,_BaseControllerBacked);function PointPlotterDirective(){_classCallCheck(this,PointPlotterDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(PointPlotterDirective,[{key:'objectBindings',get:function()
{
return['points','pointHeight','plotArea','horizontalAxis','verticalMargin','pointTopY'];
}},{key:'textBindings',get:function()
{
return['class','mask','timeProperty'];
}},{key:'controller',get:function()

{
return PointPlotterController;
}}]);return PointPlotterDirective}(BaseControllerBackedDirective);let


PointPlotterController=function(){_createClass(PointPlotterController,null,[{key:'$inject',get:function()
{
return['$scope','$element','$compile'];
}}]);

function PointPlotterController($scope,$element,$compile){var _this2=this;_classCallCheck(this,PointPlotterController);
this._$scope=$scope;
this._$element=$element;
this._$compile=$compile;

this.hitAreaWidth=0;

$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);

}
});
}PointPlotterController.prototype.

_getPointInfos=function _getPointInfos(){var _this3=this;
return this.points.map(function(point){return{
point:point,
x:_this3.horizontalAxis.scale(point.getTime())}});

};PointPlotterController.prototype.

_getLineInfos=function _getLineInfos(){
let actualPointHeight=_.exists(this.pointHeight)?
this.pointHeight:
this.plotArea.graphAreaDimensions.height;
let pointTopY=this.plotArea.graphAreaDimensions.height-actualPointHeight;

if(_.exists(this.pointTopY)){
pointTopY=this.pointTopY;
actualPointHeight-=this.pointTopY;
}

if(_.exists(this.verticalMargin)){
pointTopY+=this.verticalMargin;
actualPointHeight-=this.verticalMargin*2;
}

return{
x1:function(_ref){let{x:x}=_ref;return x},
x2:function(_ref2){let{x:x}=_ref2;return x},
y1:pointTopY,
y2:actualPointHeight,
class:this.class};

};PointPlotterController.prototype.

_getHitAreaInfos=function _getHitAreaInfos(){var _this4=this;
const lineInfos=this._getLineInfos();
return{
x:function(_ref3){let{x:x}=_ref3;return x-_this4.hitAreaWidth/2},
y:lineInfos.y1,
width:this.hitAreaWidth,
height:lineInfos.y2,
fill:'transparent',
class:this.class};

};PointPlotterController.prototype.

_drawLines=function _drawLines(pointGroup,pointInfos){
pointGroup.selectAll('line').
data(pointInfos).
enter().
append('line').
attr(this._getLineInfos());
};PointPlotterController.prototype.

_drawHitAreas=function _drawHitAreas(pointGroup,pointInfos){
if(_.exists(this.hitAreaWidth)&&this.hitAreaWidth>0){
pointGroup.selectAll('rect').
data(pointInfos).
enter().
append('rect').
attr(this._getHitAreaInfos()).
append('svg:title').
text(function(pi){return pi.tooltipText?`${pi.tooltipText}`:void 0});
}
};PointPlotterController.prototype.

_precompileStep=function _precompileStep(){

return;
};PointPlotterController.prototype.

_drawMask=function _drawMask(pointGroup){
if(_.exists(this.mask)&&this.mask.length>0){
pointGroup.
attr('mask',`url(#${this.mask}-${this.plotArea.id})`).
append('rect').attr({

height:'100%',
width:'100%',
fill:'none'});

}
};PointPlotterController.prototype.

redraw=function redraw(){var _this5=this;
if(!_.exists(this.horizontalAxis||this.horizontalAxis.scale||this.plotArea.svgElement)){
return;
}

fastdom.mutate(function(){
const svgContainer=d3.select(_this5.plotArea.svgElement);
const pointGroup=svgContainer.append('g');

pointGroup.attr({
class:_this5.class,
transform:`translate(0, ${_this5.plotArea.graphAreaBoundaries.top})`});


const pointInfos=_this5._getPointInfos(_this5.points);
_this5._drawLines(pointGroup,pointInfos);
_this5._drawHitAreas(pointGroup,pointInfos);
_this5._precompileStep(pointGroup);
_this5._drawMask(pointGroup);

if(_this5._childScope){
_this5._childScope.$destroy();
}

_this5._childScope=_this5._$scope.$new();
_this5._compiledHtml=_this5._$compile(_this5.plotArea.svgElement)(_this5._childScope);
});
};return PointPlotterController}();


module.exports=PointPlotterDirective;
module.exports.Controller=PointPlotterController;
//# sourceMappingURL=pointPlotterDirective.js.map
